import React from "react";
import { BaseIcon, BaseIconProps } from "./baseIcon";

export const PerpsIcon = (props: BaseIconProps) => {
  return (
    <BaseIcon {...props} viewBox="0 0 20 20">
      <path
        d="M14.3213 2.44141C16.0928 2.44149 17.4989 3.94461 17.499 5.77441V14.1084C17.4989 15.9382 16.0928 17.4413 14.3213 17.4414H5.67578C3.90506 17.4414 2.49919 15.9382 2.49902 14.1084V5.77441C2.49919 3.94456 3.90505 2.44141 5.67578 2.44141H14.3213ZM4.16504 7.44141V14.1084C4.1652 15.0399 4.84838 15.7744 5.67578 15.7744H5.83203V7.44141H4.16504ZM7.49902 7.44141V15.7744H14.3213C15.1495 15.7743 15.8319 15.0398 15.832 14.1084V7.44141H7.49902ZM10.2441 9.41113C10.5696 9.0857 11.0974 9.0857 11.4229 9.41113L13.0889 11.0771C13.4143 11.4026 13.4143 11.9304 13.0889 12.2559L11.4229 13.9229C11.0975 14.2482 10.5696 14.2481 10.2441 13.9229C9.91871 13.5974 9.91873 13.0696 10.2441 12.7441L11.3213 11.667L10.2441 10.5889C9.91889 10.2635 9.91894 9.73654 10.2441 9.41113ZM5.67578 4.1084C4.84838 4.1084 4.1652 4.8429 4.16504 5.77441H15.832C15.8319 4.84296 15.1495 4.10849 14.3213 4.1084H5.67578Z"
        fill="url(#paint0_linear_perps)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_perps"
          x1="17.499"
          y1="9.9414"
          x2="2.49902"
          y2="9.9414"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="rgb(var(--oui-gradient-brand-end))" />
          <stop offset="1" stopColor="rgb(var(--oui-gradient-brand-start))" />
        </linearGradient>
      </defs>
    </BaseIcon>
  );
};
